import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class MenuOptionsFilter extends Vue {
  @Prop({ default: null }) selectedMenuOption;
  @Prop({ default: () => [] }) menuOptions;

  getMenuOptionPictureUrl(menuOption) {
    const { menu_option_picture } = menuOption;
    if (menu_option_picture.url) return menu_option_picture.url;
    else
      return "https://s3.us-east-1.amazonaws.com/mimenu.todoscomemos.com/imgs/icons/Empty - Category.svg";
  }
}
